<template>
  <div class="comment d-flex align-items-start mt-3">
    <!--              <el-popover-->
    <!--                                placement="top-start"-->
    <!--                                :width="340"-->
    <!--                                trigger="hover"-->
    <!--                                :open-delay="700"-->
    <!--                            >-->

    <!--                <User-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">-->
    <!--                </User-Infor-Card>-->
    <a slot="reference" v-if="$store.state.user.check_is_wxc_domain()"
       :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
      <avatar
          style="border-radius: 50%!important"
          :data="data.userinfo_userID" :imgHeight="38" class="mr-2"></avatar>
    </a>
    <router-link
        v-else
        :to="'/userindex/'+data.userinfo_userID">
      <avatar :data="data.userinfo_userID" :imgHeight="38" class="mr-2"></avatar>
    </router-link>
    <!--  </el-popover>-->
    <div class="flex-fill">
      <div class="d-flex w-100">
        <span class="replyName pt-1">{{ data.userinfo_userID.username }}
        </span>
        <!--        <el-tag  v-if="$store.state.group.groupTopBar.auth
        or===$store.state.user.userinfo.postInfo_postID" class="bg-white mx-1 px-1 pt-0 float-left d-none d-sm-block mt-1" size="small">作者</el-tag>-->
        <span class="replyTime pt-2">{{ data.edit_date * 1000 | formatDate }}</span>
<!--        <span class="ml-auto " >-->
<!--          <drop-down-->
<!--              placement="bottom-end"-->
<!--              class="nav-item dropdown"-->
<!--              :haiwaiIcon="iconmore3v"-->
<!--              :hideArrow="true"-->
<!--              haiwaiClass="haiwaiicon"-->
<!--              style="padding:0;"-->
<!--          >-->
<!--            <a class="dropdown-item pl-4" href="javascript:void(0)" style="color:gray" @click="blockUser(data.userID)">{{ $t('message').article.black_list }}</a>-->
<!--          </drop-down>-->
<!--        </span>-->
      </div>
      <p class="replyContent" v-html="data.postInfo_postID.msgbody"></p>
      <div class="replyFoot">
        <!-- like -->
        <span class="mr-4" @click="like(currentItem)">
          <icon-like-outline
              :style="{fill:currentItem.postInfo_postID.is_buzz==1?'#39b8eb':'gray',height:'18px',cursor:'pointer'}"></icon-like-outline>
          {{ currentItem.countinfo_postID.count_buzz }}
        </span>

        <!-- 回复 -->
        <icon-message :style="{fill:'gray',height:'18px'}"></icon-message>
        <a href="javascript:void(0)" slot="reference" @click="reply()"
           style="color:gray"><span>{{ show_reply ? '取消' : $t('message').article.reply }}</span></a>
        <!-- 编辑 -->
        <icon-edit :style="{fill:'gray',height:'18px'}" class="ml-3" v-if="canEdit"></icon-edit>
        <a href="javascript:void(0)" slot="reference" @click="editReply()" v-if="canEdit"
           style="color:gray"><span>{{ show_edit ? '取消' : $t('message').article.edit }}</span></a>
        <!-- 删除 -->
        <el-popconfirm v-if="data.userID==loginuserID || author==loginuserID  || $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                       placement="top-end"
                       :confirm-button-text="$t('message').article.comment_delet"
                       :cancel-button-text="$t('message').article.comment_cancel"
                       :title="$t('message').article.comment_del_confirm"
                       :hide-icon="true"
                       @confirm="article_reply_delete(data)"
        >
          .<a href="javascript:void(0)" slot="reference" class="ml-5"
              style="color:gray"><i class="el-icon-delete"></i>{{ $t('message').article.comment_delet }}</a>
        </el-popconfirm>
        <!-- 管理员删除 -->
        <!--        <span v-if="$store.state.user.userinfo.UserLevel==6 || $store.state.group.groupTopBar.auth>1">-->
        <!--          <span v-if="data.visible==0" class="text-warning mx-3">已删除</span>-->
        <!--&lt;!&ndash;          <a v-if="data.visible==0" href="javascript:void(0)" @click="admin_reply_delete(data,1)">恢复</a>&ndash;&gt;-->

        <!--          <el-popconfirm v-if="data.visible!==0"-->
        <!--                         placement="top-end"-->
        <!--                         confirm-button-text='删除'-->
        <!--                         cancel-button-text='取消'-->
        <!--                         title="确定删除这条评论吗？其下的所有回复将一并删除！"-->
        <!--                         :hide-icon="true"-->
        <!--                         @confirm="admin_reply_delete(data,0)"-->
        <!--          >-->
        <!--            <a href="javascript:void(0)" slot="reference" class="ml-5">管理员删除</a>-->
        <!--          </el-popconfirm>-->
        <!--        </span>-->
      </div>
      <div class="groupEditar" v-if="show_reply||show_edit">
        <wxc-editor :data="data" :action="action" v-on:submited="rewriteComment($event)" @cancled="closeEditor()"></wxc-editor>
      </div>
    </div>
  </div>
</template>
<script>
// import {DropDown} from '@/components';
import Avatar from '@/module/group/pages/components/Main/Avatar';
import HaiwaiIcons from "@/components/Icons/Icons";
import {IconEdit, IconLikeOutline, IconMessage} from '@/components/Icons';
import {formatDate} from '@/directives/formatDate.js';
import WxcEditor from '../editor/index.vue';
import blog from './../../../blog/blog.service';
export default {
  name: 'comment-item',
  props: {
    data: {},
    author: Number,
    level: Number
  },
  components: {
    Avatar,
    // DropDown,
    IconLikeOutline,
    IconMessage,
    IconEdit,
    WxcEditor
  },
  data() {
    return {
      iconmore3v: HaiwaiIcons.iconmore3v,
      show_reply: false,
      show_edit: false,
      loginuserID: 0,
      action: '',
      auth: this.$store.state.group.groupTopBar.auth
      ,
      currentItem:Object.assign({},this.data),
    }
  },
  computed: {
    canEdit() {
      return this.loginuserID === this.data.userID
    },
    has_author () {
      let s = 0
      this.data.reply.forEach(obj=>{
        if(obj.userID == this.author) {
          s++
        } ;
      })
      return s>0?true:false
    }
  },
  created() {
  },
  mounted() {
    let userinfor = this.$store.state.user.userinfo;
    this.loginuserID = userinfor ? userinfor.UserID : -1;
  },
  methods: {
    reply() {
      if (this.auth == 0) {
        this.$message.warning('加入群吧才能回复！');
      } else {
        this.action = this.level ? 'reply2' : 'reply';
        this.show_edit = false;
        this.show_reply = !this.show_reply;
      }
    },
    editReply() {
      this.action = 'editreply';
      this.show_reply = false;
      this.show_edit = !this.show_edit;
    },
    closeEditor(){
      this.show_reply = false;
      this.show_edit = false;
    },
    rewriteComment(res) {
      if (res.status) {
        this.$store.dispatch('group/RewriteComment', res.data);
      }
      this.show_reply = false;
      this.show_edit = false;
    },
    like(item) {
      if(!this.check_user_login())  return;
      item.postInfo_postID.is_buzz == 0 ? this.buzz_add(item) : this.buzz_delete(item);
    },
    buzz_add(item){
      blog.buzz_add(item.postID).then(res=>{
        if(res.status){
          this.currentItem.postInfo_postID.is_buzz =1;
          this.currentItem.countinfo_postID.count_buzz++
        }
      })
    },
    buzz_delete(item){
      blog.buzz_delete(item.postID).then(res=>{
        if(res.status){
          this.currentItem.postInfo_postID.is_buzz =0;
          this.currentItem.countinfo_postID.count_buzz--
        }
      })
    },
    getComment() {
      this.$store.dispatch('group/GetArticalViewComment', {
        id: this.$route.query.postID,
        lastID: this.$store.state.group.article_view_comment.lastID
      })
    },
    article_reply_delete(item) {
      this.$store.dispatch('group/ReplyDelete', item.postID).then(res => {
        if (res.status) {
          this.getComment();
          this.$message.success('评论已删除!');
          location. reload()

        }
        else {
          this.$message.error('删除出了点状况');
        }
      })
    },
    // admin_reply_delete(item, visible) {
    //   this.$store.state.user.admin_reply_delete(item.postID, visible).then(res => {
    //     if (res.status) {
    //       item.visible = visible
    //       this.$message.success('评论已删除!');
    //       location. reload()
    //     }
    //     else {
    //       this.$message.error('删除出了点状况');
    //     }
    //   })
    // },
    //拉黑
    blockUser(id){
      if(!this.check_user_login())  return;
      this.$store.state.user.blacklist_add(id).then(res=>{
        if(res.status){
          this.$message({message:'已加黑名单',type:'success'})
        }
      })
    },
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
}
</script>
<style>
.groupEditar {
  height: 250px;
}
blockquote {
  background-color: #efefef;
  padding: 10px;
  border: 1px solid #d0d0d0;
}
/*.rounded{border-radius: 50%!important}*/
</style>